import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./create-application-details-wams.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./create-application-details-wams.component.scss?ngResource";
import { ChangeDetectorRef, Component } from "@angular/core";
import { CreateApplicationViewBaseComponent } from "../../../shared/create-application-view-base/create-application-view-base.component";
import { SharedConstants } from "../../../../shared/constants/shared.constants";
import { ApplicationCreateService } from "../../../shared/application-create.service";
import { AflaModuleStrategyService } from "../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { AppControllerService } from "../../../../app-controller.service";
import { CRUDOperation } from "../../../../shared/models/crud-operation-enum.model";
import { CreateApplicationDetailsWamsConstants } from "./create-application-details-wams.constants";
import { CompareDatesUtil } from "../../../../shared/utils/date-field-validator.utils";
import { SelectedApplicationService } from "../../../../shared/services/selected-application/selected-application.service";
import { DatePipe } from "@angular/common";
export let CreateApplicationDetailsWamsComponent = class CreateApplicationDetailsWamsComponent extends CreateApplicationViewBaseComponent {
    applicationCreateService;
    aflaModuleStrategyService;
    selectedApplicationService;
    datePipe;
    appControllerService;
    changeDetectorRefs;
    detailsForm;
    validationMessages = CreateApplicationDetailsWamsConstants.VALIDATION_MESSAGES;
    dropdownPlaceholderMessage = SharedConstants.PLACEHOLDER_TEXT;
    descriptionFormControlName = CreateApplicationDetailsWamsConstants.DESCRIPTION_FORM_CONTROL_NAME;
    clientReferenceNumberFormControlName = CreateApplicationDetailsWamsConstants.CLIENT_REFERENCE_NUMBER_FORM_CONTROL_NAME;
    applicantTelecommunicationLicenseNumberFormControlName = CreateApplicationDetailsWamsConstants.APPLICANT_TELECOMMUNICATION_LICENCE_NUMBER_FORM_CONTROL_NAME;
    scopeOfWorkFormControlName = CreateApplicationDetailsWamsConstants.SCOPE_OF_WORK_FORM_CONTROL_NAME;
    estimatedConstructionCostFormControlName = CreateApplicationDetailsWamsConstants.ESTIMATED_CONSTRUCTION_COST_FORM_CONTROL_NAME;
    applicationFeeFormControlName = CreateApplicationDetailsWamsConstants.APPLICATION_FEE_FORM_CONTROL_NAME;
    constructionPeriodInWeeksFormControlName = CreateApplicationDetailsWamsConstants.CONSTRUCTION_PERIOD_FORM_CONTROL_NAME;
    proposedStartDateFormControlName = CreateApplicationDetailsWamsConstants.PROPOSED_START_DATE_FORM_CONTROL_NAME;
    proposedEndDateFormControlName = CreateApplicationDetailsWamsConstants.PROPOSED_END_DATE_FORM_CONTROL_NAME;
    laneClosureIsRequiredFormControlName = CreateApplicationDetailsWamsConstants.LANE_CLOSURE_IS_REQUIRED_FORM_CONTROL_NAME;
    laneClosureExtentFormControlName = CreateApplicationDetailsWamsConstants.LANE_CLOSURE_EXTENT_FORM_CONTROL_NAME;
    electricalServicesFormControlName = CreateApplicationDetailsWamsConstants.ELECTRICAL_SERVICES_FORM_CONTROL_NAME;
    descriptionLabel = CreateApplicationDetailsWamsConstants.DESCRIPTION_LABEL;
    clientReferenceNumberLabel = CreateApplicationDetailsWamsConstants.CLIENT_REFERENCE_NUMBER_LABEL;
    applicantTelecommunicationLicenseNumberLabel = CreateApplicationDetailsWamsConstants.APPLICANT_TELECOMMUNICATION_LICENCE_NUMBER_LABEL;
    scopeOfWorkFormLabel = CreateApplicationDetailsWamsConstants.SCOPE_OF_WORK_LABEL;
    estimatedConstructionCostLabel = CreateApplicationDetailsWamsConstants.ESTIMATED_CONSTRUCTION_COST_LABEL;
    applicationFeeLabel = CreateApplicationDetailsWamsConstants.APPLICATION_FEE_LABEL;
    constructionPeriodInWeeksLabel = CreateApplicationDetailsWamsConstants.CONSTRUCTION_PERIOD_LABEL;
    proposedStartDateLabel = CreateApplicationDetailsWamsConstants.PROPOSED_START_DATE_LABEL;
    proposedEndDateLabel = CreateApplicationDetailsWamsConstants.PROPOSED_END_DATE_LABEL;
    laneClosureIsRequiredLabel = CreateApplicationDetailsWamsConstants.LANE_CLOSURE_IS_REQUIRED_LABEL;
    laneClosureExtentLabel = CreateApplicationDetailsWamsConstants.LANE_CLOSURE_EXTENT_LABEL;
    electricalServicesLabel = CreateApplicationDetailsWamsConstants.ELECTRICAL_SERVICES_LABEL;
    applicationTypes = [];
    zones = [];
    yesNoOptions = [];
    laneClosureExtentOptions = [];
    electricalServicesOptions = [];
    dateValidationError = CreateApplicationDetailsWamsConstants.DATE_VALIDATION_ERROR;
    constructor(applicationCreateService, aflaModuleStrategyService, selectedApplicationService, datePipe, appControllerService, changeDetectorRefs) {
        super(applicationCreateService, aflaModuleStrategyService, selectedApplicationService);
        this.applicationCreateService = applicationCreateService;
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.selectedApplicationService = selectedApplicationService;
        this.datePipe = datePipe;
        this.appControllerService = appControllerService;
        this.changeDetectorRefs = changeDetectorRefs;
    }
    ngOnInit() {
        this.initForm();
        this.getLookups();
        this.getMetadata();
    }
    loadMetadata(stepMeta) {
    }
    verifyProposedDates(formControlName) {
        // checks if the startDate is >= endDate
        CompareDatesUtil.verifyProposedDates(this.detailsForm, this.proposedStartDateFormControlName, this.proposedEndDateFormControlName, formControlName, this.appControllerService);
    }
    initForm() {
        const form = this.aflaModuleStrategyService.form.get("detailsForm");
        this.detailsForm = form;
        this.detailsForm.enable();
    }
    getLookups() {
        const params = {
            $filter: `moduleId eq ${this.applicationCreateService.moduleID} and (name eq 'LaneClosureExtent' or name eq 'ElectricalServices')`,
        };
        this.applicationCreateService
            .getLookupsObservable(params)
            .subscribe((response) => this.onGetLookupsCompleted(response), (error) => {
            this.appControllerService.handleServerErrorMessage(CreateApplicationDetailsWamsConstants.STEP_TITLE, error, CRUDOperation.Get);
        });
    }
    onGetLookupsCompleted(response) {
        this.laneClosureExtentOptions = [];
        this.electricalServicesOptions = [];
        if (response && response.value.length > 0) {
            response.value.forEach(item => {
                if (item.name === "LaneClosureExtent") {
                    this.laneClosureExtentOptions.push(JSON.parse(item.content));
                }
                if (item.name === "ElectricalServices") {
                    this.electricalServicesOptions.push(JSON.parse(item.content));
                }
            });
        }
        this.yesNoOptions = [];
        // tslint:disable-next-line:forin
        for (const yesnoenumKey in SharedConstants.YES_NO_ENUM) {
            this.yesNoOptions.push(SharedConstants.YES_NO_ENUM[yesnoenumKey]);
        }
        this.changeDetectorRefs.detectChanges();
        this.subscribeToSelectedApplication();
    }
    subscribeToSelectedApplication() {
        this.cleanupAfterDestroy(this.selectedApplicationService.$selectedApplication).subscribe((application) => {
            if (application) {
                this.setApplicationDetails(application);
            }
        });
    }
    setApplicationDetails(application) {
        // checks the application has application details set
        this.detailsForm.reset();
        if (application.description) {
            this.detailsForm.get(this.descriptionFormControlName).setValue(application.description);
        }
        if (application.scopeOfWork) {
            this.detailsForm.get(this.scopeOfWorkFormControlName).setValue(application.scopeOfWork);
        }
        if (application.clientReferenceNumber) {
            this.detailsForm.get(this.clientReferenceNumberFormControlName).setValue(application.clientReferenceNumber);
        }
        if (application.licenceNumber) {
            this.detailsForm.get(this.applicantTelecommunicationLicenseNumberFormControlName).setValue(application.licenceNumber);
        }
        if (application.applicationFee) {
            this.detailsForm.get(this.applicationFeeFormControlName).setValue(application.applicationFee);
        }
        if (application.estimatedCost) {
            this.detailsForm.get(this.estimatedConstructionCostFormControlName).setValue(application.estimatedCost);
        }
        if (application.proposedStartDate) {
            this.detailsForm.get(this.proposedStartDateFormControlName).setValue(this.datePipe.transform(application.proposedStartDate, "yyyy-MM-dd"));
        }
        if (application.proposedEndDate) {
            this.detailsForm.get(this.proposedEndDateFormControlName).setValue(this.datePipe.transform(application.proposedEndDate, "yyyy-MM-dd"));
        }
        if (application.laneClosureRequired) {
            this.detailsForm.get(this.laneClosureIsRequiredFormControlName).setValue(application.laneClosureRequired);
        }
        if (application.laneClosureExtent) {
            this.detailsForm.get(this.laneClosureExtentFormControlName).setValue(application.laneClosureExtent);
        }
        if (application.constructionPeriod) {
            this.detailsForm.get(this.constructionPeriodInWeeksFormControlName).setValue(application.constructionPeriod);
        }
        if (application.electricalServices) {
            this.detailsForm.get(this.electricalServicesFormControlName).setValue(application.electricalServices);
        }
    }
    static ctorParameters = () => [
        { type: ApplicationCreateService },
        { type: AflaModuleStrategyService },
        { type: SelectedApplicationService },
        { type: DatePipe },
        { type: AppControllerService },
        { type: ChangeDetectorRef }
    ];
};
CreateApplicationDetailsWamsComponent = __decorate([
    Component({
        selector: "app-create-application-details-wams",
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    })
], CreateApplicationDetailsWamsComponent);
